import { Component, OnInit } from '@angular/core';
import { Event, NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  standalone: false,
})
export class TopNavbarComponent implements OnInit {
  pictureUrl: string;
  public email: string;

  constructor(private router: Router, public auth: AuthService) {
    router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: Event) => {

        // Hubspot code tracking to track every page visit of our customers.
        const _hsq = window['_hsq'] = window['_hsq'] || [];
        _hsq.push(['setPath', { path: (event as RouterEvent).url }]);
        _hsq.push(['trackPageView']);
      });
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      this.refresh();
    });

    this.refresh();
  }

  refresh() {
    this.auth.user$.subscribe(user => {
      this.email = user.email;
      this.pictureUrl = user.picture;
    });

    this.auth.getAccessTokenSilently({
      authorizationParams: {
        audience: environment.auth0Audience,
        scope: 'openid profile email read:all',
      },
    }).subscribe(value => {
      console.log(value);
    }, error => {
      this.auth.getAccessTokenWithPopup({
        authorizationParams: {
          audience: environment.auth0Audience,
          scope: 'openid profile email read:all',
        },
      }).subscribe(value => {
        console.log(value);
      }, error => {
        console.log(error);
      });
    });
    //
    // this.menuService.updateActiveMenu();
  }


  public getReturnUrl(): string {
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '') + '/logged-out';
  }
}
